import React from "react"

import "./generic-modal.scss"

export default function GenericModal({ noClose, handleClose, children }) {
  return (
    <div className={"generic-modal"}>
      <div className="generic-modal-container">
        {!noClose && (
          <button
            className="generic-modal-btn-close f-concentrate-modal-btn-close"
            onClick={() => {
              if (handleClose) handleClose()
            }}
          >
            X
          </button>
        )}
        {children}
      </div>
    </div>
  )
}
